<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { Kube } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditKube from './EditKube.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        kube: Kube;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="kube">
        <EditKube
            v-if="hasPermission(Permission.SYSTEM_UPDATE)"
            :kube="kube"
        />
        <Delete
            v-if="hasPermission(Permission.SYSTEM_DELETE)"
            :route="route('v2.kube.destroy', kube.id)"
            :query-key="[QueryKey.KUBE]"
            header="kube.delete.title"
            description="kube.delete.content"
        />
    </DataTableActions>
</template>
